<template>
  <b-modal
    id="team-delete-modal"
    ref="teamDeleteModal"
    modal-class="delete-modal"
    size="sm">
    <div class="text-center">
      <h5>Are you sure you want to delete this team? (Members will be attached to main team.)</h5>
    </div>
    <template slot="modal-footer">
      <b-button @click="hide">
        Close
      </b-button>
      <b-button
        :disabled="deleting"
        @click="commitDelete">
        Yes
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'TeamDeleteModal',
  props: {
    teamp: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      deleting: false,
    };
  },
  computed: {
    ...mapGetters({
      teamDeleted: 'team/teamDeleted',
      apiError: 'team/apiError',
    }),
  },
  watch: {
    teamDeleted(deleted) {
      if (deleted) {
        this.$emit('deleted', deleted);
        this.hide();
      }
    },
  },
  methods: {
    ...mapActions({
      deleteTeam: 'team/deleteTeam',
    }),
    commitDelete() {
      this.deleting = true;
      this.deleteTeam({
        merchant_id: this.$route.params.merchant_id,
        team_id: this.teamp.id,
      });
    },
    show() {
      this.$refs.teamDeleteModal.show();
    },
    hide() {
      this.deleting = false;
      this.$refs.teamDeleteModal.hide();
    },
  },
};
</script>
